// extracted by mini-css-extract-plugin
module.exports = {"segmentsContent":"segments_segmentsContent__l1_8C"};